module.exports = __webpack_public_path__ + "8998387ad13b27a7aa71fe9762ad6111.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/official-icons/donation.png
// module id = 1072
// module chunks = 0